import ReactDOM from "react-dom";
import React from "react";
import { PaobcApp } from "../pageComponents/paobcPage/paobc-page";

ReactDOM.render(<PaobcApp />, document.querySelector("#PaobcPage"));
